// import React from "react";
// import medixo from '../../../images/home/medixo.svg'
// import taxongo from '../../../images/home/tax-on-go.svg'
// import tracxn from '../../../images/home/tracxn.svg'
// import microsoft from '../../../images/home/microsoft.svg'
// import aws from '../../../images/home/aws.svg'
// import googleCloud from '../../../images/home/google-cloud.svg'
// import ambitionbox from '../../../images/home/ambitionbox.svg'
// import clutch from '../../../images/home/clutch-logo.svg'
// import googleReviews from '../../../images/home/google-review.svg'
// import glassdoor from '../../../images/home/glassdoor.svg'
// import { Container, Row, Col } from "react-bootstrap";
// import awardLogo from '../../../images/home/top-software-development-company.png'
// import "../home.css"

// const ProductPartners = () => {
//     return (
//         <>
//             <section className="product-partners-wrapper">
//                 <Container fluid>
//                     <Row className="d-flex position-relative">
//                         <Col xs="12" lg="3" className="product-section d-flex flex-column">
//                             <h1 className="text-primary ft-wt-600 text-uppercase mb-4 text-center">Our Products</h1>
//                             <Row className="gap-0 gap-lg-4 justify-content-center">
//                                 <Col xs="4" lg="12" className="d-flex align-items-center justify-content-center my-0 my-lg-3">
//                                     <img src={medixo} alt="medixo" loading="lazy" className="img-fluid" />
//                                 </Col>
//                                 <Col xs="4" lg="12" className="d-flex align-items-center justify-content-center my-0 my-lg-3">
//                                     <img src={taxongo} alt="taxongo" loading="lazy" className="img-fluid" />
//                                 </Col>
//                                 <Col xs="4" lg="12" className="d-flex align-items-center justify-content-center my-0 my-lg-3">
//                                     <img src={tracxn} alt="tracxn" loading="lazy" className="img-fluid" />
//                                 </Col>
//                             </Row>
//                         </Col>

//                         <Col xs={12} lg={1} className="d-none d-lg-flex justify-content-center">
//                             <div className="vertical-divider"></div>
//                         </Col>

//                         <Col xs={12} lg={3} className="partner-section mt-4 mt-lg-0 d-flex flex-column">
//                             <h1 className="text-primary ft-wt-600 text-uppercase mb-4 text-center">Our Partners</h1>
//                             <Row className="gap-0 gap-lg-4 justify-content-center">
//                                 <Col xs="4" lg="12" className="d-flex align-items-center justify-content-center my-3">
//                                     <img src={microsoft} alt="microsoft" loading="lazy" className="img-fluid" />
//                                 </Col>
//                                 <Col xs="4" lg="12" className="d-flex align-items-center justify-content-center my-3">
//                                     <img src={aws} alt="aws" loading="lazy" className="img-fluid" />
//                                 </Col>
//                                 <Col xs="4" lg="12" className="d-flex align-items-center justify-content-center my-3">
//                                     <img src={googleCloud} alt="google-cloud" loading="lazy" className="img-fluid" />
//                                 </Col>
//                                 <Col xs="4" lg="12" className="d-flex align-items-center justify-content-center my-3">
//                                     <img src={awardLogo} alt="design-rush" loading="lazy" className="img-fluid" />
//                                 </Col>
//                             </Row>
//                         </Col>
//                         <Col xs={12} lg={1} className="d-none d-lg-flex justify-content-center">
//                             <div className="vertical-divider"></div>
//                         </Col>
//                         <Col xs={12} lg={3} className="partner-section mt-4 mt-lg-0">
//                             <h1 className="text-primary ft-wt-600 text-uppercase mb-4 text-center">Our Ratings</h1>
//                             <Row className="justify-content-center">
//                                 <Col xs="6" lg="12" className="my-1 d-flex align-items-center justify-content-center">
//                                     <a className="cursor-pointer" href="https://clutch.co/profile/acubetech-solutions#highlights" rel="noreferrer" target="_blank" >
//                                         <div>
//                                             <img src={clutch} alt="clutch" loading="lazy" className="img-fluid mb-2" />
//                                             <h6 className="text-primary text-center fw-bold text-decoration-underline">Know More</h6>
//                                         </div>
//                                     </a>
//                                 </Col>
//                                 <Col xs="6" lg="12" className="d-flex align-items-center justify-content-center my-1">
//                                     <a className="cursor-pointer" href="https://www.ambitionbox.com/reviews/acubetech-solutions-reviews" rel="noreferrer" target="_blank" >
//                                         <div>
//                                             <img src={ambitionbox} alt="ambitionbox" loading="lazy" className="img-fluid mb-2" />
//                                             <h6 className="text-primary text-center fw-bold text-decoration-underline">Know More</h6>
//                                         </div>
//                                     </a>
//                                 </Col>
//                                 <Col xs="6" lg="12" className="d-flex align-items-center justify-content-center my-1">
//                                     <a className="cursor-pointer" href="https://www.google.com/search?q=ACubetech+Solutions+Pvt+Ltd" rel="noreferrer" target="_blank" >
//                                         <div>
//                                             <img src={googleReviews} alt="google-review" loading="lazy" className="img-fluid mb-2" />
//                                             <h6 className="text-primary text-center fw-bold text-decoration-underline">Know More</h6>
//                                         </div>
//                                     </a>
//                                 </Col>
//                                 <Col xs="6" lg="12" className="d-flex align-items-center justify-content-center my-3">
//                                     <a className="cursor-pointer" href="https://www.glassdoor.co.in/Reviews/ACubetech-Solutions-Reviews-E1344716.htm" rel="noreferrer" target="_blank" >
//                                         <div>
//                                             <img src={glassdoor} alt="glassdoor" loading="lazy" className="img-fluid mb-2" />
//                                             <h6 className="text-primary text-center fw-bold text-decoration-underline">Know More</h6>
//                                         </div>
//                                     </a>
//                                 </Col>
//                             </Row>
//                         </Col>
//                     </Row>
//                 </Container>
//             </section>
//         </>
//     );
// };

// export default ProductPartners;


// new version

import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "../home.css";

// Assets
import medixo from '../../../images/home/medixo.svg'
import taxongo from '../../../images/home/tax-on-go.svg'
import tracxn from '../../../images/home/tracxn.svg'
import microsoft from '../../../images/home/microsoft.svg'
import aws from '../../../images/home/aws.svg'
import googleCloud from '../../../images/home/google-cloud.svg'
import ambitionbox from '../../../images/home/ambitionbox.svg'
import clutch from '../../../images/home/clutch-logo.svg'
import googleReviews from '../../../images/home/google-review.svg'
import glassdoor from '../../../images/home/glassdoor.svg'
import awardLogo from '../../../images/home/top-software-development-company.png'

const ProductPartners = () => {
    return (
        <section className="ecosystem-wrapper py-5 bg-light-subtle">
            <Container fluid="lg">
                <Row className="g-4 g-xl-5">

                    {/* --- OUR PRODUCTS --- */}
                    <Col xs={12} lg={4}>
                        <Card className="bento-card h-100 border-0 shadow-sm p-4 p-xl-5 bg-white">
                            <h3 className="bento-title">Our Products</h3>
                            <div className="d-flex flex-column justify-content-between h-100 mt-4 gap-4">
                                <div className="logo-wrapper">
                                    <img src={medixo} alt="Medixo" loading="lazy" />
                                </div>
                                <div className="logo-wrapper">
                                    <img src={taxongo} alt="TaxOnGo" loading="lazy" />
                                </div>
                                <div className="logo-wrapper">
                                    <img src={tracxn} alt="Tracxn" loading="lazy" />
                                </div>
                            </div>
                        </Card>
                    </Col>

                    {/* --- OUR PARTNERS --- */}
                    <Col xs={12} lg={4}>
                        <Card className="bento-card h-100 border-0 shadow-sm p-4 p-xl-5 bg-white">
                            <h3 className="bento-title">Our Partners</h3>
                            <div className="d-flex flex-column justify-content-between h-100 mt-4 gap-4">
                                <div className="logo-wrapper">
                                    <img src={microsoft} alt="Microsoft Partner" loading="lazy" />
                                </div>
                                <div className="logo-wrapper">
                                    <img src={aws} alt="AWS Partner Network" loading="lazy" />
                                </div>
                                <div className="logo-wrapper">
                                    <img src={googleCloud} alt="Google Cloud" loading="lazy" />
                                </div>
                                <div className="logo-wrapper award-wrapper">
                                    <img src={awardLogo} alt="Top Software Development Company 2025" loading="lazy" />
                                </div>
                            </div>
                        </Card>
                    </Col>

                    {/* --- OUR RATINGS --- */}
                    <Col xs={12} lg={4}>
                        <Card className="bento-card h-100 border-0 shadow-sm p-4 p-xl-5 bg-white">
                            <h3 className="bento-title">Our Ratings</h3>
                            <div className="mt-4 d-flex flex-column gap-3 h-100 justify-content-center">

                                <a href="https://clutch.co/profile/acubetech-solutions#highlights" target="_blank" rel="noreferrer" className="rating-tile">
                                    <img src={clutch} alt="Clutch Rating" loading="lazy" className="rating-img" />
                                    <span className="hover-arrow">&rarr;</span>
                                </a>

                                <a href="https://www.ambitionbox.com/reviews/acubetech-solutions-reviews" target="_blank" rel="noreferrer" className="rating-tile">
                                    <img src={ambitionbox} alt="AmbitionBox Rating" loading="lazy" className="rating-img" />
                                    <span className="hover-arrow">&rarr;</span>
                                </a>

                                <a href="https://www.google.com/search?q=ACubetech+Solutions+Pvt+Ltd" target="_blank" rel="noreferrer" className="rating-tile">
                                    <img src={googleReviews} alt="Google Reviews" loading="lazy" className="rating-img" />
                                    <span className="hover-arrow">&rarr;</span>
                                </a>

                                <a href="https://www.glassdoor.co.in/Reviews/ACubetech-Solutions-Reviews-E1344716.htm" target="_blank" rel="noreferrer" className="rating-tile">
                                    <img src={glassdoor} alt="Glassdoor Rating" loading="lazy" className="rating-img" />
                                    <span className="hover-arrow">&rarr;</span>
                                </a>

                            </div>
                        </Card>
                    </Col>

                </Row>
            </Container>
        </section>
    );
};

export default ProductPartners;